export default __webpack_public_path__ + "940070e89406014d944b33f7edf3afd3.png";